// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  seasonId: __t.u32().name("season_id"),
  challengeType: __t.string().name("challenge_type"),
  title: __t.string(),
  description: __t.string(),
  requirementType: __t.string().name("requirement_type"),
  requirementValue: __t.u32().name("requirement_value"),
  xpReward: __t.u64().name("xp_reward"),
  rotationSlot: __t.u32().name("rotation_slot"),
  activeFrom: __t.u64().name("active_from"),
  activeUntil: __t.u64().name("active_until"),
});
